import axios from 'axios';
import qs from 'qs';

export const getLessonLocalizations = (lessonId: string) =>
  axios.get(`/api/v1/lesson-localizations/${lessonId}`);

export const getLessonLocalization = ({
  lessonId,
  locale,
  merged = false,
}: {
  lessonId: string;
  locale: string;
  merged?: boolean;
}) =>
  axios.get(
    `/api/v1/lesson-localizations/${lessonId}/${locale}?${qs.stringify({ merged })}`,
  );

export const upsertLessonLocalization = ({
  lessonId,
  locale,
  lessonType,
  payload,
}: {
  lessonId: string;
  locale: string;
  lessonType: string;
  payload: Record<string, any>;
}) =>
  axios.put(`/api/v1/lesson-localizations/${lessonId}/${locale}`, {
    lessonType,
    payload,
  });

export const generateLessonLocalizationFrom = ({
  lessonId,
  locale,
  sourceLocale,
  lessonType,
  fields,
}: {
  lessonId: string;
  locale: string;
  sourceLocale: string;
  lessonType: string;
  fields?: string[];
}) =>
  axios.post(
    `/api/v1/lesson-localizations/${lessonId}/${locale}/generate-from/${sourceLocale}`,
    {
      lessonType,
      ...(fields ? { fields } : {}),
    },
  );
